import { render } from "./ProjectSection.vue?vue&type=template&id=628c0d72"
import script from "./ProjectSection.vue?vue&type=script&lang=js"
export * from "./ProjectSection.vue?vue&type=script&lang=js"

import "./ProjectSection.vue?vue&type=style&index=0&id=628c0d72&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__